<template>
  <span>
    <b-modal id="localeResetModal" title="Taal reset" hide-footer>
    <b-form @submit.prevent="syncSalesforce">
      <p>Klik op de knop 'Taal reset starten' om voor alle portaal gebruikers de taal te resetten.</p>
      <hr>
      <b-button class="pull-left" variant="danger" @click="closeModal">Annuleer</b-button>
      <b-button type="submit" class="pull-right" variant="success">Taal reset starten</b-button>
    </b-form>
  </b-modal>
    <b-button variant="primary" v-b-modal.localeResetModal>Taal reset starten</b-button>
  </span>

</template>

<script>

import {getData} from "@/api";

export default {
  name: 'DefaultUserLocaleResetButton',
  methods: {
    async syncSalesforce() {
      const response = await getData('locale-reset').then(response => response.data);
      alert(response.message);
      this.closeModal();
    },
    async closeModal() {
      this.$bvModal.hide('localeResetModal');
    }
  }
}
</script>
